import SchedulePipelineModal from './SchedulePipelineModal';

export default SchedulePipelineModal;
